var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "row g-3",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.checkIfEmailIsTakenAndSignUp()
        }
      }
    },
    [
      _c("div", { staticClass: "col-6" }, [
        _c(
          "label",
          {
            staticClass: "form-label fw-bold",
            attrs: { for: "input-publishing-company" }
          },
          [_vm._v("Publishing Company")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loginData.company,
              expression: "loginData.company"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", id: "input-publishing-company", required: "" },
          domProps: { value: _vm.loginData.company },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.loginData, "company", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c(
          "label",
          {
            staticClass: "form-label fw-bold",
            attrs: { for: "input-country" }
          },
          [_vm._v("Country")]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.country,
                expression: "loginData.country"
              }
            ],
            staticClass: "form-select",
            attrs: { id: "input-country", required: "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.loginData,
                  "country",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { disabled: "", selected: "" } }, [
              _vm._v("Choose...")
            ]),
            _vm._v(" "),
            _vm._l(_vm.countriesList, function(countryName, countryISO) {
              return _c(
                "option",
                {
                  key: "country-" + countryISO,
                  domProps: { value: countryISO }
                },
                [_vm._v(_vm._s(countryName))]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "label",
          {
            staticClass: "form-label fw-bold",
            attrs: { for: "input-first-name" }
          },
          [_vm._v("First Name")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loginData.first_name,
              expression: "loginData.first_name"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", id: "input-first-name", required: "" },
          domProps: { value: _vm.loginData.first_name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.loginData, "first_name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "label",
          {
            staticClass: "form-label fw-bold",
            attrs: { for: "input-last-name" }
          },
          [_vm._v("Last Name")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loginData.last_name,
              expression: "loginData.last_name"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", id: "input-last-name", required: "" },
          domProps: { value: _vm.loginData.last_name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.loginData, "last_name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "label",
          { staticClass: "form-label fw-bold", attrs: { for: "input-email" } },
          [_vm._v("Email")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loginData.email,
              expression: "loginData.email"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "email", id: "input-email", required: "" },
          domProps: { value: _vm.loginData.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.loginData, "email", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.accept_terms,
                expression: "loginData.accept_terms"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "checkbox", id: "check-terms", required: "" },
            domProps: {
              checked: Array.isArray(_vm.loginData.accept_terms)
                ? _vm._i(_vm.loginData.accept_terms, null) > -1
                : _vm.loginData.accept_terms
            },
            on: {
              change: function($event) {
                var $$a = _vm.loginData.accept_terms,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.loginData, "accept_terms", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.loginData,
                        "accept_terms",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.loginData, "accept_terms", $$c)
                }
              }
            }
          }),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 mt-0" }, [
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.agree_newsletter,
                expression: "loginData.agree_newsletter"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "checkbox", id: "check-newsletter", required: "" },
            domProps: {
              checked: Array.isArray(_vm.loginData.agree_newsletter)
                ? _vm._i(_vm.loginData.agree_newsletter, null) > -1
                : _vm.loginData.agree_newsletter
            },
            on: {
              change: function($event) {
                var $$a = _vm.loginData.agree_newsletter,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.loginData,
                        "agree_newsletter",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.loginData,
                        "agree_newsletter",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.loginData, "agree_newsletter", $$c)
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "check-newsletter" }
            },
            [
              _vm._v(
                "\n\t\t\t\t\tI agree to receive monthly email marketing from Babel-Bridge\n\t\t\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c("small", { staticClass: "d-block" }, [
            _vm._v(
              "(opt-out easy from your Account Settings, should you change your mind)"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 text-center" }, [
        _vm.registering
          ? _c(
              "button",
              {
                staticClass: "btn dm-btn-padding",
                attrs: { type: "submit", disabled: "" }
              },
              [
                _vm._v("\n\t\t\t\tRegistering... "),
                _c("svg-icon", {
                  staticClass: "dm-spinner",
                  attrs: { icon: "fa-spinner" }
                })
              ],
              1
            )
          : _c(
              "button",
              { staticClass: "btn dm-btn-padding", attrs: { type: "submit" } },
              [_vm._v("Register")]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 text-center" }, [
        _vm._v("\n\t\t\tAlready have an account? \n\t\t\t\n\t\t\t"),
        _vm.login_link
          ? _c(
              "a",
              {
                staticClass: "fw-bold text-decoration-underline",
                attrs: { href: _vm.login_link }
              },
              [_vm._v("\n\t\t\t\tLog in!\n\t\t\t")]
            )
          : _c(
              "a",
              {
                staticClass: "fw-bold text-decoration-underline",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("showSignInModal")
                  }
                }
              },
              [_vm._v("\n\t\t\t\tLog in!\n\t\t\t")]
            )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: "check-terms" } },
      [
        _vm._v("\n\t\t\t\t\tI agree with the "),
        _c("u", [
          _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
            _vm._v("Terms and Conditions")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-0" }, [
      _c("small", [
        _vm._v(
          "Non-disclosure: You agree that the material you access will only be read for work and only shared professionally."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }